import { useState } from 'react'
import { Box } from '@mui/system'
import { useDispatch } from 'react-redux'
import { Menu, MenuItem, Button, Typography } from '@mui/material'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { useSnackbar } from 'notistack'
import { motion } from 'motion/react'
import UseTranslation from '../../hooks/UseTranslation'
import { arrowRotate } from '../../utils/animation'

const SortByList = ({ actionToDispatch, store, sendQueryAsObject, actionProps = {} }) => {
  const dispatch = useDispatch()
  const [anchorEl, setAnchorEl] = useState(null)
  const { enqueueSnackbar } = useSnackbar()
  const open = Boolean(anchorEl)
  const { t } = UseTranslation()
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const handleSelection = (name) => {
    dispatch(actionToDispatch({
      queries: sendQueryAsObject
        ? { activeSort: name, ...actionProps }
        : name })).then((response) => {
      if (response.meta.requestStatus === 'rejected') {
        enqueueSnackbar('Could not perform sort', { variant: 'error' })
      }
    })
    handleClose()
  }

  return (
    <>
      <Box sx={styles.sortContainer}>
        <Typography variant="body1" sx={styles.sortTxt}>
        {`${t?.['Sort By']}`} :
        </Typography>
        <Button
          id="sortBy-button"
          sx={styles.sortBtn}
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
            endIcon={(
            <KeyboardArrowUpIcon
              component={motion.svg}
              variants={arrowRotate}
              initial="initial"
              animate={open ? 'animate' : 'initial'}
              transition="transition"
            />
)}
          onClick={handleClick}>
          {store.activeSort?.value || ''}
        </Button>
      </Box>

      <Menu
        id="sortBy-menu"
        sx={styles.sortMenu}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}>
        {store?.sortBy?.map((item, index) => (
          <MenuItem key={index} onClick={() => handleSelection(item)} sx={styles.listItem}>
            {item.value}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

const styles = {
  sortContainer: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 'max-content',
  },
  sortTxt: {
    color: 'text.hint',
    fontSize: { xs: '14px', sm: '18px' },
  },
  sortBtn: {
    color: '#000',
    fontSize: { xs: '14px', sm: '18px' },
    backgroundColor: 'transparent !important',
    textTransform: 'capitalize',
    '& span': {
      color: 'text.hint',
    },
  },
  sortMenu: {
    '.MuiMenu-paper': {
      minWidth: { xs: '130px', sm: '160px' },
    },
    ul: {
      padding: { xs: '0px 0px', sm: '0px 8px' },
    },
    li: {
      textTransform: 'capitalize',
      fontSize: { xs: '11px', sm: '14px' },
      padding: { xs: '0px 16px', sm: '6px 16px' },
      minHeight: { xs: '32px', sm: '48px' },
    },
  },
}

export default SortByList
